import { EditorState } from 'draft-js';
import { ValidationErrors } from 'final-form';
import { isEmpty } from 'lodash';
import { required } from '@qwealth/kyc';
import { QNoteRaw } from 'data/models/qnoteForm';

export default (values: QNoteRaw, editorState: EditorState): ValidationErrors => {
  const hasContent = editorState.getCurrentContent().hasText() || !isEmpty(values.pending);
  return {
    title: required(values.title, 'Title'),
    content: hasContent ? undefined : 'Note content is required',
  };
};
